import { SheetController } from "~/components/Base/Sheet/controller";

export const useNewSheetController = () => {
  return ref(new SheetController());
};
